import axios from 'axios';
import Cookies from 'universal-cookie';

export const authConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.teammezzo.com',
  redirectUri: '/auth/callback',
  loginRedirectRoute: '/dashboard',
  logoutRedirectRoute: '/login',
};

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.teammezzo.com',
  headers: {
    'X-TenantId': localStorage.getItem('tenantId') || '',
  },
  withCredentials: true,
});

const cookies = new Cookies();

client.interceptors.request.use((config) => {
  const token = cookies.get('access-token') || null;
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export { client };
